import { render, staticRenderFns } from "./changeRemark.vue?vue&type=template&id=413b9a2e"
import script from "./changeRemark.vue?vue&type=script&lang=js"
export * from "./changeRemark.vue?vue&type=script&lang=js"
import style0 from "./changeRemark.vue?vue&type=style&index=0&id=413b9a2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports